import axios from "axios";
import { BASE_URL } from "./apiConfig";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/*
  Sessão morta derruba para o login.

  O token do staff vale 1 dia. Sem este interceptor, depois de expirar a
  pessoa ficava numa tela que carregava para sempre — toda chamada voltava
  403 e cada componente mostrava o próprio erro genérico, sem ninguém dizer
  "entre de novo".

  O 403 do login NÃO entra aqui: credencial errada não é sessão expirada, e
  recarregar a página de login em cima de quem está digitando esconderia a
  mensagem de erro.

  Recusa de permissão também não: o servidor responde 403 tanto para sessão morta
  quanto para "cliente fora da sua carteira", e derrubar a sessão nesse caso jogava a
  pessoa no login sem dizer o que aconteceu. As mensagens abaixo são as de sessão, em
  app/src/admin/middlewares/authenticateStaff.js. Sem mensagem legível (um download,
  um proxy no caminho), continua valendo cair para o login.
*/
const SESSION_DENIED_MESSAGES = [
  "Sessão expirada ou inválida",
  "Token não é de back-office",
  "Usuário inativo ou inexistente",
];

const isSessionDead = (response) => {
  if (response?.status === 401) return true;
  if (response?.status !== 403) return false;

  const message = response.data?.message;
  return typeof message !== "string" || SESSION_DENIED_MESSAGES.includes(message);
};

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest = String(error.config?.url || "").includes("/login");

    if (isSessionDead(error.response) && !isLoginRequest) {
      localStorage.removeItem("token");

      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login?expirada=1";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
